import React from "react";
import { getCurrentYear } from "../../../../common/shared";

const SelectYear = ({ value, onChange, length, error }) => {
  const currentYear = getCurrentYear();

  const years = Array.from(
    new Array(length ? length : 30),
    (val, index) => index + currentYear
  );

  const errorClass = error ? "year-select validation-error" : "year-select";

  return (
    <select className={errorClass} onChange={onChange}>
      {years.map((year, index) => (
        <option key={`year${index}`} value={year} selected={year === value}>
          {year}
        </option>
      ))}
    </select>
  );
};

export default SelectYear;
